import { useEffect, useMemo, useState } from 'react';
import { Globe2 } from 'lucide-react';

const faviconPaths = ['/favicon.ico', '/favicon.svg', '/favicon-96x96.png', '/apple-touch-icon.png'];

function faviconCandidates(value: string) {
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:') return [];
    return faviconPaths.map(path => new URL(path, url.origin).toString());
  } catch {
    return [];
  }
}

export function MonitorFavicon({ url, label: _label }: { url: string; label?: string }) {
  const candidates = useMemo(() => faviconCandidates(url), [url]);
  const [candidateIndex, setCandidateIndex] = useState(0);

  useEffect(() => setCandidateIndex(0), [url]);

  const source = candidates[candidateIndex];
  return <span className="monitor-favicon" aria-hidden="true">
    {source ? <img src={source} alt="" onError={() => setCandidateIndex(index => index + 1)} /> : null}
    {!source && <Globe2 size={18} strokeWidth={1.8} aria-hidden="true" />}
  </span>;
}
